/**
 * TextBody, pure half.
 *
 * Moved verbatim from components/FlowBuilder/flow-components/components/TextBodyComponent.js. Runs unchanged in the
 * browser and, via the flow-core bundle, inside GraalJS on the backend, so it
 * must never reach for React, the DOM, Node APIs, or the network.
 */

export const TextBodyCore = {
  type: 'TextBody',
  name: 'Text Body',
  icon: '📃',
  description: 'Standard paragraph text for the main content of a screen.',
  category: 'display',
  maxPerScreen: null,
  getDefaultProperties() {
    return {
      text: 'Body text content',
      visible: true,
    };
  },
  getPropertySchema() {
    return {
      text: {
        type: 'string',
        label: 'Text',
        required: true,
        maxLength: 4096,
      },
      visible: {
        type: 'boolean',
        label: 'Visible',
        required: false,
      },
    };
  },
  validateProperties(properties) {
    const errors = [];
    const warnings = [];

    if (!properties.text || properties.text.trim().length === 0) {
      errors.push('Body text is required');
    }

    if (properties.text && properties.text.length > 4096) {
      errors.push('Body text must be 4096 characters or less');
    }

    return { errors, warnings };
  },
  transformToWhatsApp(properties) {
    return {
      type: 'TextBody',
      text: properties.text,
    };
  },
  transformFromWhatsApp(whatsappComponent) {
    return {
      text: whatsappComponent.text,
      visible: true,
    };
  },
};
